import React, { useState } from 'react';
import { QRCode, Button, Input, Upload, Card, message } from 'antd';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';

export default function QRCodeGenerator() {
    const [url, setUrl] = useState('https://example.com');
    const [logoUrl, setLogoUrl] = useState('');
    const [imageFile, setImageFile] = useState(null);

    const handleImageUpload = (info) => {
        console.log('Image uploaded:', info);
        const file = info;
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setLogoUrl(e.target.result);
                setImageFile(file);
                console.log('Logo URL:', e);
                console.log('Image File:', file);
            };
            reader.readAsDataURL(file);
        }
        return false;
    };

    const downloadQRCode = () => {
        const canvas = document.getElementById('qrCodeCanvas')?.querySelector('canvas');
        if (canvas) {
            const url = canvas.toDataURL('image/png');
            const a = document.createElement('a');
            a.download = 'qrcode.png';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            message.success('QR Code downloaded successfully!');
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-8">
            <div className="max-w-4xl mx-auto">
                <Card className="shadow-lg">
                    <h1 className="text-3xl font-bold text-center mb-8 text-indigo-700">
                        QR Code Generator
                    </h1>

                    <div className="grid md:grid-cols-2 gap-8">
                        <div className="space-y-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Enter URL
                                </label>
                                <Input
                                    placeholder="https://example.com"
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                    size="large"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Upload Logo (Optional)
                                </label>
                                <Upload
                                    beforeUpload={handleImageUpload}
                                    showUploadList={false}
                                    accept="image/*"
                                >
                                    <Button icon={<UploadOutlined />} block size="large">
                                        Choose Image
                                    </Button>
                                </Upload>
                                {imageFile && (
                                    <p className="mt-2 text-sm text-gray-600">
                                        Selected: {imageFile.name}
                                    </p>
                                )}
                            </div>

                            <Button
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={downloadQRCode}
                                size="large"
                                block
                                className="bg-indigo-600 hover:bg-indigo-700"
                            >
                                Download QR Code
                            </Button>
                        </div>

                        <div className="flex flex-col items-center justify-center bg-white p-6 rounded-lg border-2 border-gray-200">
                            <div id="qrCodeCanvas">
                                <QRCode
                                    value={url || 'https://example.com'}
                                    size={256}
                                    icon={logoUrl}
                                    iconSize={94}
                                    errorLevel="H"
                                />
                            </div>
                            <p className="mt-4 text-sm text-gray-500 text-center">
                                Your QR code will appear here
                            </p>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}